import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@qualtrics/ui-react/icons';
import { IconButton } from '@qualtrics/ui-react';
import styles from './customTextDisplay.module.css';

const CustomTextDisplay = ({ textContent }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [height, setHeight] = useState(`5%`);

    const handleCloseCustomText = () => {
        setHeight(`5%`);
        setIsCollapsed(true);
    };

    const handleOpenCustomText = () => {
        setHeight(`60%`);
        setIsCollapsed(false);
    };

    return (
        <div 
            className={styles['custom-text-container']}
            height={height}
        >
            { !isCollapsed && (
                <div className={styles['description-container']}>
                    <div className={styles['description']}>
                        {textContent}
                    </div>
                    <IconButton 
                        aria-label="Chevron Up" 
                        tooltipContent="Hide custom message"
                        className={styles['chevron-up-icon-container']}
                        onClick={handleCloseCustomText}
                    >
                        <ChevronUpIcon/>
                    </IconButton>
                </div>
            )}
            { isCollapsed && (
                <div>
                    <IconButton 
                        aria-label="Chevron Down" 
                        tooltipContent="Show custom message"
                        className={styles['chevron-down-icon-container']}
                        onClick={handleOpenCustomText}
                    >
                        <ChevronDownIcon/>
                    </IconButton> 
                </div>
            )}
        </div>
    );
};

export default CustomTextDisplay;